import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useAppContext } from "../../../../context/AppContext";
//primereact
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
//components
import NumberInput from "../../../../components/input/NumberInput";
//services
import {postSingleParcel} from "../../../../services/Settings/Simulator/postSingleParcel";

const SingleParcel = ({ setActiveIndex, info, loading, refetch }) => {
  const form = useForm();
  const errors = form.formState.errors;

  const { id } = useParams();
  const [loadingButton, setLoadingButton] = useState(false);

  const { nomenclatures } = useAppContext();
  const nomenclature = JSON.parse(nomenclatures);

  const onSubmit = async (data) => {
    setLoadingButton(true);
    const notification = toast.loading("Por favor aguarde...");
    data.enterprise_id = parseInt(id);
    data.single_installment_enable = info.single_installment_enable;
    const response = await postSingleParcel(data);
    if (response.success) {
      refetch().then(() => {
        toast.update(notification, {
          render: "Informações Atualizadas com Sucesso",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
        refetch();
        setLoadingButton(false);
      });
    } else {
      toast.update(notification, {
        render: "Ocorreu algum erro!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
      setLoadingButton(false);
    }
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  useEffect(() => {
    if (info) {
      const defaultValues = {
        single_installment_percentage: info.single_installment_percentage,
      };
      form.reset(defaultValues);
    }
  }, [info]);
  return (
    <>
      <Panel
        header={
          <div className="flex align-items-center">
            <i className="fa-solid fa-key"></i>
            <span className="mx-2 vertical-align-middle">Parcela Única</span>
          </div>
        }
      >
        <div className="row">
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-md-5 mt-3">
                <h3>
                  {" "}
                  Percentual Destinado à parcela única
                  <Tooltip target=".custom-target-icon" />
                  <i
                    className="custom-target-icon px-2 pi 
                              pi-info-circle p-text-secondary"
                    data-pr-tooltip={`Quanto do ${nomenclature[1].value} que será distribuído em parcela única`}
                    style={{ cursor: "pointer" }}
                  ></i>
                </h3>
                <NumberInput
                  name="single_installment_percentage"
                  suffix="%"
                  placeholder="0%"
                  max={100}
                  minFractionDigits={2}
                  control={form.control}
                  label="Percentual"
                  getFormErrorMessage={getFormErrorMessage}
                />
              </div>

              <div className="d-flex justify-content-end mt-3">
                <div className="col-md-2 text-end">
                  <Button
                    rounded
                    type="submit"
                    iconPos="right"
                    label="Salvar"
                    loading={loadingButton}
                    icon="fa-solid fa-check"
                    className="p-inputtext-sm m-auto"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </Panel>
    </>
  );
};

export default SingleParcel;
